<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-10-21 18:00:22
--> 
<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1"
                      step="1">{{$t('label_The_general_information')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2"
                      step="2">{{$t('label_The_template')}}</v-stepper-step>

    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <commoninfor @changee1='changee1'></commoninfor>
      </v-stepper-content>

      <v-stepper-content step="2">
        <emailtemplate @changee1='changee2'
                       :commoninforloading='loading'
                       :function_uuid='function_uuid'
                       @submit="submit"></emailtemplate>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>

<script>
import commoninfor from './modules/commoninfor'
import emailtemplate from './modules/emailtemplate'
import { addemailtemplate } from '@/service/api/emailtemplate'

export default {
  components: {
    commoninfor,
    emailtemplate
  },
  data () {
    return {
      loading: false,
      e1: 1,
      function_uuid: '',
      addlist: {}, //一般资料
      addlist2: {}//模板
    }
  },
  mounted () {

  },
  methods: {
    changee2 (num, val1) {
      this.e1 = num
    },
    changee1 (num, val1) {
      this.e1 = num
      val1 ? this.addlist = val1 : ''
      this.function_uuid = val1.function_uuid
    },
    async submit (val) {
      this.loading = true
      await addemailtemplate({ ...this.addlist, ...val })
        .then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_added_successfully') })
            this.$router.push({
              name: 'emailtemplate'
            })
          }
        })
      this.loading = false
    }
  }
}
</script>
<style scoped>
.v-stepper__content {
  padding: 0px 0px;
}
</style>